namespace $ {

	/** Bounded address lookup for committed reference positions. */
	export class $shm_hitalama_map_history_storage_target_writer_index extends $giper_baza_entity.with({
		Positions: $giper_baza_dict_to( $giper_baza_atom_dict ),
		Routing: $giper_baza_atom_bool,
	}) {
		/** A missing key is meaningful only after the first remote land response. */
		@ $mol_mem
		ready() {
			$shm_hitalama_map_history_storage_ready.settled(this)
			return this
		}
	}

}
